import { Card } from "react-bootstrap";
import CustomButton from "../../components/CustomButton/CustomButton";
import { useNavigate } from "react-router-dom";

const PageBuilder = () => {
    const navigate = useNavigate();

    return (
        <>
            <div className="events-main">
                <Card className='event-card'>
                    <div className='d-flex justify-content-end'>
                        <CustomButton
                            isLoading={false}
                            label='Add New Page'
                            onClick={() => {
                                navigate('/add-page-builder')
                            }}
                            style={{ width: 180 }}
                        />
                    </div>
                    {/* <CustomTable
                        columns={[
                            { id: 'name', label: 'Category Name', minWidth: 170 },
                            { id: 'action', label: 'Action', minWidth: 100, align: 'center' },
                        ]}
                        rows={categories}
                        totalCount={totalCount}
                        currentPage={currentPage}
                        pageSize={itemsPerPage}
                        onPageChange={(page) => {
                            setCurrentPage(page);
                        }}
                    /> */}
                </Card>
            </div>
        </>
    )
}

export default PageBuilder;